import styled from "styled-components";
import InputWithLabel from "shared/components/InputWithLabel";
import { TeacherInputs } from "shared/types/teacher";
import { hw } from "features/homework/homeworkUi";

interface Props {
    teacherInputs: TeacherInputs;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const NormalInputs = ({ teacherInputs, onChange }: Props) => {
    return (
        <Container>
            <Title>추가 정보</Title>
            <Inputs>
                <InputWithLabel 
                    label="전화번호" 
                    value={teacherInputs.tel} 
                    onChange={onChange} 
                    name="tel"
                    placeholder="전화번호를 입력해주세요"
                />
                <InputWithLabel 
                    label="이메일" 
                    value={teacherInputs.email} 
                    onChange={onChange} 
                    name="email"
                    placeholder="이메일을 입력해주세요"
                />
                <AddressField>
                    <InputWithLabel 
                        label="주소" 
                        value={teacherInputs.address} 
                        onChange={onChange} 
                        name="address"
                        placeholder="주소를 입력해주세요"
                    />
                </AddressField>
            </Inputs>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${hw.bg};
    padding: 20px 22px;
    border-radius: 14px;
    border: 1px solid ${hw.border};
`

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`

const Inputs = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 20px;

    @media (max-width: 800px) {
        grid-template-columns: 1fr;
    }
`

const AddressField = styled.div`
    grid-column: 1 / -1;
`

export default NormalInputs;
